export const getFirstName = (fullName: string): string => {
  const names = fullName.trim().split(' ');

  return names[0] ?? '';
};
